import type { StyleRules } from '@material-ui/core/styles';
import { withStyles } from '@material-ui/core/styles';

export default withStyles(() => {
  const styles: StyleRules = {
    container: {
      background: '#f5f5f5',
      fontSize: '0.875rem',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      gap: '12px',
      padding: '10px',
    },

    text: {
      color: '#000',
    },
  };

  return styles;
});
